import styled from "styled-components";
import { getTypographyStyles } from "@security-watchdog/sw-ui-kit";

export const Container = styled.div`
  padding: 24px;
  margin-top: 24px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors["color-surface-default"]};
`;

export const Section = styled.section`
  margin-bottom: 24px;
`;

export const Title = styled.h2`
  ${getTypographyStyles({ variant: "h3" })};
  margin: 0;
`;

export const Text = styled.p`
  ${getTypographyStyles({ variant: "body-wide-line" })};
  margin: 0;
`;

const InfoBanner = styled.div`
  display: flex;
  align-content: center;
  gap: 16px;
  padding: 16px 8px 16px 16px;
  background: ${({ theme }) => theme.colors["color-surface-warning-default"]};
  border-radius: 4px;
`;

export const PageInfoBanner = styled(InfoBanner)`
  margin-bottom: 28px;
`;

export const ConfirmModalInfoBanner = styled(InfoBanner)``;

export const InfoBannerIcon = styled.div`
  flex: 0 0 auto;
`;

export const InfoBannerText = styled.div`
  text-align: left;
`;

export const ConfirmationModalSubHeader = styled.div`
  text-align: left;
  margin-bottom: 16px;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
